// @ts-strict

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class AssetResolver {
  constructor(private http: HttpClient) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Blob> {
    const assetPath = 'assets/documents/' + route.paramMap.get('documentName');
    return this.http.get(assetPath, { responseType: 'blob' });
  }
}
